import * as React from "react";
import Modal from "../../../core/ui/modal";
import Input from "../../../core/ui/input";
import Button from "../../../core/ui/button";

interface Props {
    visible: boolean;
    onCancel: () => void;
    price: string | undefined;
    onSetPrice: (price: string) => void;
    title: string;
}

interface State {
    price: string;
    showConfirmation: boolean;
}

export default class PriceModal extends React.Component<Props, State> {
    state: State = {
        price: this.props.price || "",
        showConfirmation: false,
    };

    handlePriceChange(price: string): void {
        this.setState({ price });
    }

    showConfirmation(): void {
        this.setState({ showConfirmation: true });
    }

    hideConfirmation(): void {
        this.setState({ showConfirmation: false });
    }

    render(): JSX.Element {
        const { visible, onCancel, onSetPrice, title } = this.props;
        const { price, showConfirmation } = this.state;

        return (
            <>
                <Modal className="set-price-modal" closable visible={visible} onCancel={() => onCancel()} size="small">
                    {!showConfirmation ? (
                        <>
                            <h2>Set artwork price</h2>
                            <p>
                                Lorem ipsum, dolor sit amet consectetur adipisicing elit. Assumenda aperiam repellat molestias unde beatae
                                nemo aut, modi veritatis ipsa iste.
                            </p>
                            <div className="price-input-container">
                                <Input
                                    value={price}
                                    onChange={(price: string) => this.handlePriceChange(price)}
                                    extraValidation={(e) => ({
                                        valid: !isNaN(Number(e)) && Number(e) >= 0,
                                        defaultMessage: "Not a valid number",
                                    })}
                                />
                                <p className="price-suffix">credits</p>
                            </div>
                            <div className="set-price-wrapper">
                                <Button
                                    disabled={isNaN(Number(price)) || Number(price) < 0 || price === ""}
                                    onClick={() => this.showConfirmation() /*onSetPrice(price)*/}
                                >
                                    Set price
                                </Button>
                            </div>
                        </>
                    ) : (
                        <>
                            <h2>Set price confirmation</h2>
                            <p>
                                Are you sure you want to set the price of {title} to {price} credits?
                            </p>
                            <div className="price-confirmation-modal-buttons">
                                <Button onClick={() => onSetPrice(price)}>Yes</Button>
                                <Button onClick={() => this.hideConfirmation()}>No</Button>
                            </div>
                        </>
                    )}
                </Modal>
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/arts/parts/art-price-modal.tsx